import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import ProgressBar from '../components/ProgressBar';
import ScrollToTop from '../components/ScrollToTop';
import Hero from '../components/Hero';
import CEO from '../components/CEO';
import About from '../components/About';
import Services from '../components/Services';
// OurWorkDetails removed per request
import Portfolio from '../components/Portfolio';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  useEffect(() => {
    // Smooth scroll behavior
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Optional: Animate elements on scroll using Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
    });

    // Observe elements with animation class
    document.querySelectorAll('[data-animate]').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full overflow-x-hidden bg-black">
      <ProgressBar />
      <ScrollToTop />
      <Navbar />
      <Hero />
      <CEO />
      <About />
      <Services />
      <Portfolio />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
